<template>
  <el-dialog
    :title="$t('SeaExport.GeneratePrimaryDocNo')"
    :visible.sync="innerVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="400px"
  >
    <el-form>
      <el-form-item v-if="!needServiceCode" :label="$t('SeaExport.PleasePrimaryOrderNumberRule')">
        <el-select v-model="config.rule" clearable @change="handleRuleChange">
          <el-option v-for="rule in rules" :key="rule.uuid" :value="rule.name" :disabled="!!rule.partnerId && rule.partnerId!==form.carrierId" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="needServiceCode" :label="$t('SeaExport.PleaseCodeOfTheNo')">
        <el-select v-model="config.identificationCode">
          <el-option v-for="code in groupCodes" :key="code.uuid" :value="code.code" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="handleConfirm">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getOfficeConfigByName } from '@/api/user'
import { getGroupIdentification } from '@/api/groupIdentification'
import { generateMblNo } from '@/api/seaExport/mbl'
import { cleanCircleObject } from '@/utils/commonUtil'
import lodash from 'lodash'

export default {
  name: 'GenerateMblNoDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      needServiceCode: false,
      rules: [],
      curRule: null,
      groupCodes: [],
      canSave: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        } else {
          this.$emit('open')
        }
      }
    },
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.needServiceCode = false
        this.canSave = false
        getOfficeConfigByName({
          officeId: this.$store.getters.currentOfficeId,
          configName: 'SEMblNoPattern'
        }).then((res) => {
          this.rules = res.data.details
        })
      } else {
        this.curRule = null
        this.config.rule = ''
        this.config.identificationCode = ''
      }
    }
  },
  methods: {
    handleConfirm() {
      if (!this.canSave) {
        if (!this.curRule) {
          this.$message.error(this.$t('SeaExport.PleasePrimaryOrderNumberRule'))
          return
        }
        const { value } = this.curRule
        if (value.indexOf('${groupCode}') !== -1) {
          this.needServiceCode = true
          this.canSave = true
          getGroupIdentification({ officeId: this.officeId }).then(res => {
            this.groupCodes = res.data.list
            this.groupCodes.forEach(code => {
              if (code.default) {
                this.config.identificationCode = code.code
              }
            })
          })
          return
        } else {
          this.canSave = true
        }
      }
      if (this.needServiceCode && !this.config.identificationCode) {
        this.$message.error(this.$t('SeaExport.PleaseCodeOfTheNo'))
        return
      }
      console.log('cansave')
      const { identificationCode, rule } = this.config
      const job = lodash.cloneDeep(this.form)
      cleanCircleObject(job)
      generateMblNo(rule, identificationCode, { job, jobUuid: job.uuid }).then(res => {
        const { data } = res
        this.form.mbl = data
        this.config.curRule = this.curRule
        this.form.mblConfigName = this.curRule.name
        console.log(this.form)
        this.$emit('close')
      })
    },
    handleRuleChange() {
      this.curRule = this.rules.find(rule => rule.name === this.config.rule)
    }
  }
}
</script>

<style scoped>

</style>
